const NAMESPACE = "eSignatureActionRow";

const KEYS = {
    resendNotice: "resendNotice",
    resendButtonText: "resendButtonText",
    signatoryUpdate: "signatoryUpdate"
};

const MESSAGES = {
    [KEYS.resendNotice]: {
        value: "Note: After resending notifications, any changes made to signatory information will be reflected in project data as well.",
        comment: "Notice that project data will reflect changes after resending eSignature notifications"
    },
    [KEYS.resendButtonText]: {
        value: "Resend Notifications",
        comment: "Text for a resend button"
    },
    [KEYS.signatoryUpdate]: {
        value: "Signatory info updated",
        comment: "Status message wgeb signatory info is updated"
    }
};

export { NAMESPACE, KEYS, MESSAGES };
